module.exports = __webpack_public_path__ + "static/media/o4.783cab95.svg";